export default __webpack_public_path__ + "static/media/OrderStatus_3.a0ccdd1a.svg";